import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import StoreRoutes from "./routes/StoreRoutes";
import ClienteRoutes from "./routes/ClienteRoutes";
import TiendaRoutes from "./routes/TiendaRoutes";
import AdminRoutes from "./routes/AdminRoutes";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/store/inicio" replace />} />
        <Route path="/store/*" element={<StoreRoutes />} />
        <Route path="/cliente/*" element={<ClienteRoutes />} />
        <Route path="/administracion/tienda/*" element={<TiendaRoutes />} />
        <Route path="/administrator/admin/*" element={<AdminRoutes />} />
        <Route path="*" element={<Navigate to="/store/inicio" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;